import { renderFilters } from "./filters";
import { renderGridImpl } from "./grid";
import { renderDetail } from "./detail";

export function renderGrid(): void {
  renderGridImpl();
}

export { renderFilters, renderDetail };

export function renderAll(): void {
  renderFilters();
  renderGrid();
  renderDetail();
}
